import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

import SEO from '../components/SEO';

const TermsOfService = () => {
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', py: 10 }}>
            <SEO
                title="Terms of Service"
                description="Read our Terms of Service to understand the rules and regulations for using the 10D Stores platform."
                canonical="https://10dstores.in/terms-of-service"
            />
            <Container maxWidth="md">
                <Paper sx={{ p: 5, borderRadius: 4 }}>
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 4 }}>
                        Terms of Service
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                        Last Updated: December 1, 2025
                    </Typography>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            1. Acceptance of Terms
                        </Typography>
                        <Typography variant="body1" paragraph>
                            By accessing and using the 10D Stores platform, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            2. Use License
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Permission is granted to temporarily download one copy of the materials (information or software) on 10D Stores' website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            3. User Accounts
                        </Typography>
                        <Typography variant="body1" paragraph>
                            To access certain features of the platform, you may be required to create an account. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer.
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            4. Limitations
                        </Typography>
                        <Typography variant="body1" paragraph>
                            In no event shall 10D Stores or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on 10D Stores' website.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            5. Governing Law
                        </Typography>
                        <Typography variant="body1" paragraph>
                            These terms and conditions are governed by and construed in accordance with the laws of India and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default TermsOfService;
